import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BASE_URL } from '@jwt';
import { IPersistStateModel } from '../component/common/api/persist-state-model';

@Injectable({
    providedIn: 'root',
})
export class PersistStateService {
    httpClient = inject(HttpClient);
    baseUrl = inject(BASE_URL);

    private buildHttpParams(queryParams?: { [key: string]: any }): HttpParams {
        let params = new HttpParams();

        if (queryParams && Object.keys(queryParams).length > 0) {
            Object.keys(queryParams).forEach((key) => {
                if (queryParams[key] !== undefined) {
                    params = params.set(key, queryParams[key]);
                }
            });
        }
        return params;
    }

    private fetchJsonBodyGet(url: string, queryParams?: { [key: string]: any }): Promise<IPersistStateModel[]> {

        return firstValueFrom(this.httpClient.get<IPersistStateModel[]>(url, {
            params: this.buildHttpParams(queryParams)
        }));
    }

    private fetchJsonBodyPost<T>(url: string, body: any, queryParams?: { [key: string]: any }): Promise<T> {

        return firstValueFrom(this.httpClient.post<T>(url, body, {
            params: this.buildHttpParams(queryParams)
        }));
    }

    async loadData(params: any) {
        const url = `${this.baseUrl}/persistState/loadData`;

        return await this.fetchJsonBodyGet(url, params);
    }

    createOrUpdate(body: any, params: any) {
        const url = `${this.baseUrl}/persistState/createOrUpdate`;

        return this.fetchJsonBodyPost<any>(url, body, params);
    }

    remove(persistStateId: number) {
        const url = `${this.baseUrl}/persistState/remove`;

        return this.fetchJsonBodyPost<any>(url, {}, { persistStateId });
    }

    select(persistStateId: number) {
        const url = `${this.baseUrl}/persistState/select`;

        return this.fetchJsonBodyPost<any>(url, {}, { persistStateId });
    }

    primary(persistStateId: number) {
        const url = `${this.baseUrl}/persistState/markAsPrimary`;

        return this.fetchJsonBodyPost<any>(url, {}, { persistStateId });
    }
}
